import { Component, OnInit, NgZone, ApplicationRef } from '@angular/core';
import { CreateAccountService } from './create-account.service';
import { IAccount } from './account';
import { Router, NavigationExtras, ActivatedRoute } from '@angular/router';
import { FormBuilder, Validators } from '@angular/forms';
import { ICustomer } from '../home/customer';
import { Subscription } from 'rxjs';
import { IZip } from './zipinfo';
import { LoginService } from '../home/login.service';
import { IRep } from '../home/rep';
import { ProductService } from '../products/products.service';
import { AppComponent } from '../app.component';
import { PasswordValidation } from './password-validation';
import { IAddress } from './address';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { ViewChild, ElementRef } from '@angular/core';
import { OnlineOrderService } from '../onlineorder/onlineorder.service';
import { ICartItems } from '../onlineorder/cartitems';
import { OrderService } from '../onlineorder/order.service';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';
import { AdminService } from '../admin/admin.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ICustomerInfoResponse } from './customerinforesponse';
import { IAuthData } from '../seamlessauth/authData';
import { Output, EventEmitter } from '@angular/core';
import { ChangeDetectorRef } from '@angular/core';
import { ProductListComponent } from '../products/product-list.component';
import { environment } from 'environments/environment';
export class CustomModalContext {
  public num1!: number;
  public num2!: number;
}

@Component({
  standalone: false,
  selector: 'validadd',
  templateUrl: './validate-address.component.html',
  providers: [AppComponent],
})
export class ValidateAddressComponent implements OnInit {
  @Output() accountCreated = new EventEmitter<void>();
  @ViewChild('validButton') validButton!: ElementRef;
  @ViewChild('origButton') origButton!: ElementRef;

  context: CustomModalContext;
  addresses!: IAddress;
  pageTitle = 'Address Match Found';
  myCustId!: string;
  customer!: ICustomer;
  public authData: IAuthData;
  accounts!: IAccount[];
  public token: any;
  closeResult: string;
  public allCustInfo: ICustomerInfoResponse;
  public loginInfo: any;
  public checkResult!: boolean;
  public cartItems!: ICartItems[];
  errorMessage!: string;
  public caption: string;
  public transErrMsg: string;
  translatedText = '';
  constructor(
    private _createAccountService: CreateAccountService,
    public login: LoginService,
    public app: AppComponent,
    public toaster: ToastrService,
    public router: Router,
    public onlineorder: OnlineOrderService,
    private zone: NgZone,
    private orderService: OrderService,
    private modalService: NgbModal,
    public translate: TranslateService,
    public admin: AdminService,
    public spinner: NgxSpinnerService,
    private cdRef: ChangeDetectorRef,
    private appRef: ApplicationRef
  ) { }

  open(content) {
    this.modalService
      .open(content, { ariaLabelledBy: 'modal-basic-title' })
      .result.then(
        (result) => {
          this.closeResult = `Closed with: ${result}`;
        },
        (reason) => {
          this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
        }
      );
  }
  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }
  getLocale(): any {
    var currentLocale = localStorage.getItem('locale');
    return currentLocale;
  }
  googleTranslateCall(textToTrans: string, targetLang: string): string {
    let model = {
      q: [textToTrans],
      target: targetLang,
    };
    this.admin.googleTranslate(model).subscribe((response: any) => {
      //console.log('Translate Call: ' + response.data.translations[0].translatedText);
      this.translatedText = response.data.translations[0].translatedText;
      return this.translatedText;
    });
    return '';
  }
  showError(errorMessage: string, subject: string, staticErrorMsg: boolean) {
    this.spinner.hide();
    //use this for dynamic error messages
    if (staticErrorMsg === false) {
      let locale = this.getLocale();
      if (locale !== 'en') {
        //were gonna do it nested, couldn't do it as a standalone method.
        let model = {
          q: [errorMessage],
          target: locale,
        };

        this.admin.googleTranslate(model).subscribe(
          (response: any) => {
            let res = response.data.translations[0].translatedText as string;
            this.translatedText = response.data.translations[0]
              .translatedText as string;
            this.transErrMsg = this.translatedText;
            localStorage.setItem('translatedText', res);
          },
          (error) => console.log(error),
          () => {
            this.translate.get(subject).subscribe(
              (res: string) => {
                this.caption = res;
                console.log(res);
              },
              (error) => console.log(error),
              () => {
                this.spinner.hide();
                //once the caption is translated, fire off the toaster popup
                this.toaster.error(this.transErrMsg, this.caption, {
                  timeOut: 5000,
                });
                localStorage.removeItem('translatedText');
              }
            );
          }
        );

        //this.transErrMsg =  this.translatedText;
      } else {
        this.translate.get(subject).subscribe(
          (res: string) => {
            this.caption = res;
            console.log(res);
          },
          (error) => console.log(error),
          () => {
            this.transErrMsg = errorMessage;
            this.spinner.hide();
            //once the caption is translated, fire off the toaster popup
            this.toaster.error(this.transErrMsg, this.caption, {
              timeOut: 5000,
            });
            localStorage.removeItem('translatedText');
          }
        );
      }
    } else {
      // translate the error message - not dynamic
      this.translate.get(errorMessage).subscribe((res: string) => {
        this.transErrMsg = res;
        console.log(res);
      });

      // translate the caption
      this.translate.get(subject).subscribe((res: string) => {
        this.caption = res;
        console.log(res);
      });
      this.spinner.hide();
      //show the toaster popup
      this.toaster.error(this.transErrMsg, this.caption, {
        timeOut: 5000,
      });
    }
  }
  repId(): any {
    var currentId = localStorage.getItem('repId');
    return currentId;
  }

  ngOnInit() {
    //var add = JSON.parse(localStorage.getItem('validAddress'));

    this.addresses = JSON.parse(
      localStorage.getItem('validatedAddress') || '{}'
    );
    if (this.addresses.Street1 === null) {
      //do this so that we can show the bad address that needs to be fixed
      let origAdd = JSON.parse(
        localStorage.getItem('accountCreateFields') || '{}'
      );
      this.addresses.FirstName = origAdd.FirstName;
      this.addresses.LastName = origAdd.LastName;
      this.addresses.Street1 = origAdd.Street;
      this.addresses.City = origAdd.City;
      this.addresses.State = origAdd.State;
      this.addresses.PostalCode = origAdd.PostalCode;
      this.addresses.County = origAdd.County;
      this.addresses.Country = 'USA';
      this.addresses.Phone = origAdd.Phone;
      this.addresses.Email = origAdd.Email;
    }
    //console.log("VAl ADD COMP: " + this.addresses.Street1);
  }

  // createSuccess(): void {

  //     this.toaster.success("You have successfully created your account ", "Success", {
  //         timeOut: 3000
  //     });

  //     // setTimeout((router: Router) => {
  //     //     this.router.navigate(["/shop/from/" + this.repId()]);
  //     // }, 2000);
  // }
  createSuccess(message: string, caption: string): void {
    // translate the error message - not dynamic
    this.translate.get(message).subscribe((res: string) => {
      this.transErrMsg = res;
      console.log(res);
    });

    // translate the caption
    this.translate.get(caption).subscribe((res: string) => {
      this.caption = res;
      console.log(res);
    });
    this.toaster.success(this.transErrMsg, this.caption, {
      timeOut: 3000,
    });

    setTimeout((router: Router) => {
      this.router.navigate(['/shop/from/' + this.repId()]);
    }, 2000);
  }

  createAccountOriginalAddress2() {
    this.origButton.nativeElement.disabled = true;
    this.validButton.nativeElement.disabled = true;
    this.spinner.show();
    //Do some other stuff, maybe call a service etc...
    //this.submitButton.nativeElement.disabled = false;
    var cust = JSON.parse(localStorage.getItem('accountCreateFields') || '{}');
    this._createAccountService
      .createAccount2(
        cust.RepDID,
        cust.FirstName,
        cust.LastName,
        cust.Street,
        cust.City,
        cust.State,
        cust.PostalCode,
        cust.Phone,
        cust.Password,
        cust.Email,
        cust.County,
        cust.How,
        cust.Message
      )
      .subscribe(
        (data) => (this.myCustId = data),
        (error) => {
          this.showError(
            'validateAddress.modal.toastPopup.error.createError',
            'Error',
            true
          );
          this.origButton.nativeElement.disabled = false;
          this.validButton.nativeElement.disabled = false;
        },
        () =>
          this.login.someLogin(cust.Email, cust.Password).subscribe(
            (data) => (this.token = data),
            (error) =>
              this.showError(
                'validateAddress.modal.toastPopup.error.createError',
                'Error',
                true
              ),
            () => {
              this.login.getLbriWebApiToken().subscribe(
                (thing) => (this.loginInfo = thing),
                (error) => console.log(error),
                () => {
                  this.login.isAuthenticated = true;
                  this.app.loggedIn = true;
                  localStorage.setItem('cameFromCreateAccount', 'True');
                  // this._createAccountService.createNote(this.myCustId,
                  //     cust.How + " - " +
                  //     cust.Message).subscribe(data => console.log(data),
                  //     error => this.createError(), () => {
                  this.modalService.dismissAll();
                  this.createSuccess(
                    'validateAddress.modal.toastPopup.success.createAccount',
                    'validateAddress.modal.toastPopup.title.success'
                  );
                  if (this.login.loggedIn()) {
                    var myAuth = JSON.parse(
                      localStorage.getItem('authorizationData')
                    );
                    this._createAccountService
                      .getCustomerInfo(myAuth.userName)
                      .subscribe({
                        next: (custRes) => {
                          this.allCustInfo = custRes;
                          // set this to be used later.
                          localStorage.setItem(
                            'allCustInfo',
                            JSON.stringify(this.allCustInfo)
                          );
                          localStorage.setItem(
                            'shippingData',
                            JSON.stringify({
                              first: this.allCustInfo.FirstName,
                              last: this.allCustInfo.LastName,
                              street1: this.allCustInfo.ShipStreet1,
                              street2: this.allCustInfo.ShipStreet2,
                              city: this.allCustInfo.ShipCity,
                              state: this.allCustInfo.ShipState,
                              zip: this.allCustInfo.ShipPostalCode,
                              county: this.allCustInfo.ShipCounty,
                              country: 'USA',
                              email: this.allCustInfo.Email,
                              phone: this.allCustInfo.Phone1,
                            })
                          );
                          let custName = (
                            custRes.FirstName +
                            ' ' +
                            custRes.LastName
                          )
                            .toString()
                            .replace('"', '');
                          localStorage.setItem('custName', custName);
                          if (this.allCustInfo.PreferredCulture === 1)
                            this.app.useLanguage('en');
                          else this.app.useLanguage('es');
                        },
                        complete: () => {
                          this.onlineorder.latestOnlineOrder().subscribe(
                            (thing2) => (this.loginInfo = thing2),
                            (error) => (this.errorMessage = error),
                            () => {

                              //LOG ROCKET
                              if (environment.logrocketEnabled) {
                                let orderInfo = JSON.parse(localStorage.getItem('orderId'));
                                this.login.setCurrentUser(this.allCustInfo, orderInfo.ID)
                              }
                              this.onlineorder.changeMarketType().subscribe({
                                next: (v) => '',
                                error: (e) => console.error(e),
                                complete: () => {
                                  if (this.orderService.getCart().length > 0) {
                                    this.cartItems =
                                      this.orderService.getCart();
                                    var prodC = 0;
                                    for (
                                      var i = 0;
                                      i < this.orderService.getCart().length;
                                      i++
                                    ) {
                                      // see if any of the items have been ordered, if not add them to online order.
                                      this.orderService
                                        .checkIfOrdered2(
                                          this.cartItems[i].ProductId
                                        )
                                        .subscribe(
                                          null,
                                          () => {
                                            //for (var t = 0; t < this.cartItems.length; t++) {

                                            // this.checkResult = thing;
                                            //console.log(prodC);
                                            // if (this.checkResult === false && prodC <= i) {
                                            if (prodC <= i) {
                                              //console.log("good");
                                              this.orderService
                                                .mergeToOrder(prodC)
                                                .subscribe(
                                                  null,
                                                  (error) =>
                                                    (this.errorMessage = error),
                                                  () => {
                                                    this.onlineorder
                                                      .calculateTax()
                                                      .subscribe(
                                                        (thing2) => thing2,
                                                        (error) =>
                                                          console.log(error),
                                                        () => {
                                                          this.orderService
                                                            .updateShipMethodPlusTotals2()
                                                            .subscribe();
                                                        }
                                                      );
                                                  }
                                                );
                                              prodC++;
                                            } else if (
                                              prodC <=
                                              this.orderService.cart.length
                                            ) {
                                              // need to kick out the bad item
                                              console.log(prodC);
                                              var badItem: ICartItems = {
                                                ProductId:
                                                  this.cartItems[prodC]
                                                    .ProductId,
                                                DisplayName:
                                                  this.cartItems[prodC]
                                                    .DisplayName,
                                                ImageUrl:
                                                  this.cartItems[prodC]
                                                    .ImageUrl,
                                                Price:
                                                  this.cartItems[prodC].Price,
                                                Quantity:
                                                  this.cartItems[prodC]
                                                    .Quantity,
                                              };
                                              //this.cartItems = this.orderService.deleteItem(badItem);
                                              this.orderService.cart =
                                                this.orderService.deleteItem(
                                                  badItem
                                                );
                                              //console.log(JSON.stringify(this.orderService.cart));
                                              localStorage.removeItem(
                                                'cartItems'
                                              );
                                              localStorage.setItem(
                                                'cartItems',
                                                JSON.stringify(
                                                  this.orderService.getCart()
                                                )
                                              );
                                              var newCount =
                                                localStorage.getItem(
                                                  'prodCount'
                                                );

                                              var count = Number(newCount) - 1;
                                              localStorage.removeItem(
                                                'prodCount'
                                              );
                                              localStorage.setItem(
                                                'prodCount',
                                                count.toString()
                                              );

                                              this.cartItems =
                                                this.orderService.getCart();
                                              //this.cartItems = this.orderService.getCart();
                                              this.onlineorder
                                                .calculateTax()
                                                .subscribe(
                                                  (thing2) => thing2,
                                                  (error) => console.log(error),
                                                  () => {
                                                    this.orderService
                                                      .updateShipMethodPlusTotals2()
                                                      .subscribe();
                                                  }
                                                );
                                              this.showError(
                                                'validateAddress.modal.toastPopup.error.createError',
                                                'Error',
                                                true
                                              );
                                              //prodC++;
                                              //i--;
                                            }

                                            //console.log(JSON.stringify(this.cartItems) + " Product Count Index: " + prodC);
                                            //}
                                          },
                                          () => {
                                            console.log(prodC);
                                            var badItem: ICartItems = {
                                              ProductId:
                                                this.cartItems[prodC].ProductId,
                                              DisplayName:
                                                this.cartItems[prodC]
                                                  .DisplayName,
                                              ImageUrl:
                                                this.cartItems[prodC].ImageUrl,
                                              Price:
                                                this.cartItems[prodC].Price,
                                              Quantity:
                                                this.cartItems[prodC].Quantity,
                                            };
                                            //this.cartItems = this.orderService.deleteItem(badItem);
                                            this.orderService.cart =
                                              this.orderService.deleteItem(
                                                badItem
                                              );
                                            //console.log(JSON.stringify(this.orderService.cart));
                                            localStorage.removeItem(
                                              'cartItems'
                                            );
                                            localStorage.setItem(
                                              'cartItems',
                                              JSON.stringify(
                                                this.orderService.getCart()
                                              )
                                            );
                                            var newCount =
                                              localStorage.getItem('prodCount');

                                            var count = Number(newCount) - 1;
                                            localStorage.removeItem(
                                              'prodCount'
                                            );
                                            localStorage.setItem(
                                              'prodCount',
                                              count.toString()
                                            );

                                            this.cartItems =
                                              this.orderService.getCart();
                                            //this.cartItems = this.orderService.getCart();
                                            this.onlineorder
                                              .calculateTax()
                                              .subscribe(
                                                (thing2) => thing2,
                                                (error) => console.log(error),
                                                () => {
                                                  this.orderService
                                                    .updateShipMethodPlusTotals2()
                                                    .subscribe();
                                                }
                                              );
                                            this.showError(
                                              'validateAddress.modal.toastPopup.error.createError',
                                              'Error',
                                              true
                                            );
                                          }
                                          // this.checkResult = thing, error => console.log(error), () => {

                                          // }
                                        );
                                    }
                                  }
                                  this.spinner.hide();
                                  this.zone.run(() => {
                                    this.app.loggedIn = true;
                                    this.cdRef.detectChanges();
                                    setTimeout((router: Router) => {
                                      this.app.myRepID = this.repId();

                                      this.router.navigateByUrl(
                                        'shop/from/' + this.repId()
                                      );
                                    }, 1000);
                                  });
                                },
                              });
                            }
                          );
                        },
                      });
                  }
                }
              );
            }
          )
      );
  }

  createAccountValidatedAddress2() {
    this.validButton.nativeElement.disabled = true;
    this.origButton.nativeElement.disabled = true;

    this.spinner.show();
    //Do some other stuff, maybe call a service etc...
    //this.submitButton.nativeElement.disabled = false;
    var cust = JSON.parse(localStorage.getItem('accountCreateFields') || '{}');
    this._createAccountService
      .createAccount2(
        cust.RepDID,
        cust.FirstName,
        cust.LastName,
        this.addresses.Street1,
        this.addresses.City,
        this.addresses.State,
        this.addresses.PostalCode,
        cust.Phone,
        cust.Password,
        cust.Email,
        this.addresses.County,
        cust.How,
        cust.Message
      )
      .subscribe(
        (data) => (this.myCustId = data),
        (error) => {
          this.showError(
            'validateAddress.modal.toastPopup.error.createError',
            'Error',
            true
          );
          this.validButton.nativeElement.disabled = false;
          this.origButton.nativeElement.disabled = false;
        },
        () =>
          this.login.someLogin(cust.Email, cust.Password).subscribe(
            (data) => (this.token = data),
            (error) =>
              this.showError(
                'validateAddress.modal.toastPopup.error.createError',
                'Error',
                true
              ),
            () => {
              this.login.getLbriWebApiToken().subscribe(
                (thing) => (this.loginInfo = thing),
                (error) => console.log(error),
                () => {
                  console.log(
                    'ValidateAddressComponent app instance:',
                    this.app
                  );

                  //this.login.isAuthenticated = true;
                  this.zone.run(() => {
                    this.app.loggedIn = true;
                    this.login.isAuthenticated = true;
                    localStorage.setItem('cameFromCreateAccount', 'True');
                    this.appRef.tick();
                    console.log(
                      '✅ User marked logged in, change detection triggered.'
                    );
                  });
                  // this._createAccountService.createNote(this.myCustId,
                  //     cust.How + " - " +
                  //     cust.Message).subscribe(data => console.log(data),
                  //     error => this.createError(), () => {
                  this.modalService.dismissAll();
                  this.createSuccess(
                    'validateAddress.modal.toastPopup.success.createAccount',
                    'validateAddress.modal.toastPopup.title.success'
                  );

                  if (this.login.loggedIn()) {
                    var myAuth = JSON.parse(
                      localStorage.getItem('authorizationData')
                    );
                    this._createAccountService
                      .getCustomerInfo(myAuth.userName)
                      .subscribe({
                        next: (custRes) => {
                          this.allCustInfo = custRes;
                          // set this to be used later.
                          localStorage.setItem(
                            'allCustInfo',
                            JSON.stringify(this.allCustInfo)
                          );
                          localStorage.setItem(
                            'shippingData',
                            JSON.stringify({
                              first: this.allCustInfo.FirstName,
                              last: this.allCustInfo.LastName,
                              street1: this.allCustInfo.ShipStreet1,
                              street2: this.allCustInfo.ShipStreet2,
                              city: this.allCustInfo.ShipCity,
                              state: this.allCustInfo.ShipState,
                              zip: this.allCustInfo.ShipPostalCode,
                              county: this.allCustInfo.ShipCounty,
                              country: 'USA',
                              email: this.allCustInfo.Email,
                              phone: this.allCustInfo.Phone1,
                            })
                          );
                          let custName = (
                            custRes.FirstName +
                            ' ' +
                            custRes.LastName
                          )
                            .toString()
                            .replace('"', '');
                          localStorage.setItem('custName', custName);
                          this.app.myCustName = custName;
                          if (this.allCustInfo.PreferredCulture === 1)
                            this.app.useLanguage('en');
                          else this.app.useLanguage('es');
                        },
                        complete: () => {
                          this.onlineorder.latestOnlineOrder().subscribe(
                            (thing2) => (this.loginInfo = thing2),
                            (error) => (this.errorMessage = error),
                            () => {

                              //LOG ROCKET
                              if (environment.logrocketEnabled) {
                                let orderInfo = JSON.parse(localStorage.getItem('orderId'));
                                this.login.setCurrentUser(this.allCustInfo, orderInfo.ID)
                              }
                              // need to change the market type here
                              this.onlineorder.changeMarketType().subscribe({
                                next: (v) => '',
                                error: (e) => console.error(e),
                                complete: () => {
                                  if (this.orderService.getCart().length > 0) {
                                    this.cartItems =
                                      this.orderService.getCart();
                                    var prodC = 0;
                                    for (
                                      var i = 0;
                                      i < this.orderService.getCart().length;
                                      i++
                                    ) {
                                      // see if any of the items have been ordered, if not add them to online order.
                                      this.orderService
                                        .checkIfOrdered2(
                                          this.cartItems[i].ProductId
                                        )
                                        .subscribe(
                                          null,
                                          () => {
                                            if (prodC <= i) {
                                              //console.log("good");
                                              this.orderService
                                                .mergeToOrder(prodC)
                                                .subscribe(
                                                  null,
                                                  (error) =>
                                                    (this.errorMessage = error),
                                                  () => {
                                                    this.onlineorder
                                                      .calculateTax()
                                                      .subscribe(
                                                        (thing2) => thing2,
                                                        (error) =>
                                                          console.log(error),
                                                        () => {
                                                          this.orderService
                                                            .updateShipMethodPlusTotals2()
                                                            .subscribe({
                                                              next(value) {
                                                                localStorage.setItem(
                                                                  'orderInfo',
                                                                  JSON.stringify(
                                                                    value
                                                                  )
                                                                );
                                                              },
                                                            });
                                                        }
                                                      );
                                                  }
                                                );
                                              prodC++;
                                            } else if (
                                              prodC <=
                                              this.orderService.cart.length
                                            ) {
                                              // need to kick out the bad item
                                              console.log(prodC);
                                              var badItem: ICartItems = {
                                                ProductId:
                                                  this.cartItems[prodC]
                                                    .ProductId,
                                                DisplayName:
                                                  this.cartItems[prodC]
                                                    .DisplayName,
                                                ImageUrl:
                                                  this.cartItems[prodC]
                                                    .ImageUrl,
                                                Price:
                                                  this.cartItems[prodC].Price,
                                                Quantity:
                                                  this.cartItems[prodC]
                                                    .Quantity,
                                              };
                                              //this.cartItems = this.orderService.deleteItem(badItem);
                                              this.orderService.cart =
                                                this.orderService.deleteItem(
                                                  badItem
                                                );
                                              //console.log(JSON.stringify(this.orderService.cart));
                                              localStorage.removeItem(
                                                'cartItems'
                                              );
                                              localStorage.setItem(
                                                'cartItems',
                                                JSON.stringify(
                                                  this.orderService.getCart()
                                                )
                                              );
                                              var newCount =
                                                localStorage.getItem(
                                                  'prodCount'
                                                );

                                              var count = Number(newCount) - 1;
                                              localStorage.removeItem(
                                                'prodCount'
                                              );
                                              localStorage.setItem(
                                                'prodCount',
                                                count.toString()
                                              );

                                              this.cartItems =
                                                this.orderService.getCart();
                                              //this.cartItems = this.orderService.getCart();
                                              this.onlineorder
                                                .calculateTax()
                                                .subscribe(
                                                  (thing2) => thing2,
                                                  (error) => console.log(error),
                                                  () => {
                                                    this.orderService
                                                      .updateShipMethodPlusTotals2()
                                                      .subscribe({
                                                        next(value) {
                                                          localStorage.setItem(
                                                            'orderInfo',
                                                            JSON.stringify(
                                                              value
                                                            )
                                                          );
                                                        },
                                                      });
                                                  }
                                                );
                                              this.showError(
                                                'validateAddress.modal.toastPopup.error.createError',
                                                'Error',
                                                true
                                              );
                                              //prodC++;
                                              //i--;
                                            }

                                            //console.log(JSON.stringify(this.cartItems) + " Product Count Index: " + prodC);
                                            //}
                                          },
                                          () => {
                                            console.log(prodC);
                                            var badItem: ICartItems = {
                                              ProductId:
                                                this.cartItems[prodC].ProductId,
                                              DisplayName:
                                                this.cartItems[prodC]
                                                  .DisplayName,
                                              ImageUrl:
                                                this.cartItems[prodC].ImageUrl,
                                              Price:
                                                this.cartItems[prodC].Price,
                                              Quantity:
                                                this.cartItems[prodC].Quantity,
                                            };
                                            //this.cartItems = this.orderService.deleteItem(badItem);
                                            this.orderService.cart =
                                              this.orderService.deleteItem(
                                                badItem
                                              );
                                            //console.log(JSON.stringify(this.orderService.cart));
                                            localStorage.removeItem(
                                              'cartItems'
                                            );
                                            localStorage.setItem(
                                              'cartItems',
                                              JSON.stringify(
                                                this.orderService.getCart()
                                              )
                                            );
                                            var newCount =
                                              localStorage.getItem('prodCount');

                                            var count = Number(newCount) - 1;
                                            localStorage.removeItem(
                                              'prodCount'
                                            );
                                            localStorage.setItem(
                                              'prodCount',
                                              count.toString()
                                            );

                                            this.cartItems =
                                              this.orderService.getCart();
                                            //this.cartItems = this.orderService.getCart();
                                            this.onlineorder
                                              .calculateTax()
                                              .subscribe(
                                                (thing2) => thing2,
                                                (error) => console.log(error),
                                                () => {
                                                  this.orderService
                                                    .updateShipMethodPlusTotals2()
                                                    .subscribe({
                                                      next(value) {
                                                        localStorage.setItem(
                                                          'orderInfo',
                                                          JSON.stringify(value)
                                                        );
                                                      },
                                                    });
                                                }
                                              );
                                            this.showError(
                                              'validateAddress.modal.toastPopup.error.createError',
                                              'Error',
                                              true
                                            );
                                          }
                                          // this.checkResult = thing, error => console.log(error), () => {

                                          // }
                                        );
                                    }
                                  }
                                  this.spinner.hide();
                                  this.zone.run(() => {
                                    this.app.loggedIn = true;
                                    this.cdRef.detectChanges();
                                    setTimeout((router: Router) => {
                                      this.app.myRepID = this.repId();
                                      this.router.navigateByUrl(
                                        'shop/from/' + this.repId()
                                      );
                                    }, 1000);
                                  });
                                },
                              });

                              //this.orderService.clearOrder().subscribe(null,
                              //(error: string) => this.errorMessage = error, () => {
                            }
                          );
                          //});
                        },
                      });
                  }
                }
              );
            }
          )
      );
  }
}
